import React from 'react';
import { actionTypes, attachmentStatuses, companyTypes, counterpartyKind, documentBpActions as bpActions, documentStatuses, formFieldTypes, formStringFieldPatterns, formModes, alfrescoTypes, certificateAttachedTypes } from '../../constants';
import i18next from "../../i18n";
import { EditSignerForm, SignerFormTypes } from '../forms/EditSignerForm';
import { dispatcherActionTypes, globalEventDispatcher } from '../helpers/GlobalEventDispatcher';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { messageDialog, badYoucontrolRequestDialog } from '../ModalDialogsTemplates';

const statuses = Object.assign(documentStatuses, {
	rejectedCofco: "Rejected Cofco", //³������� �ofco
	Accreditation: "Accreditation", //�� ����������� �ofco
	Verification: "Verification", //�� ����������� �ofco
	Refinement: "Refinement", //�� �������������
	Processing: "Processing", //�� �������
	ProcessingCofco: "Processing Cofco", //�� ������� �ofco
	Consideration: "Consideration", //�� �������
	AgreementCofco: "Agreement Cofco", //�� ���������� �ofco
	signedCounterparty: "Signed Counterparty", //ϳ������� ������������
	Confirmed: "Confirmed", //ϳ����������
	ConfirmedCofco: "Confirmed Cofco", //ϳ���������� Cofco
	Canceled: "Canceled", //���������
	CanceledCounterparty: "Canceled Counterparty", //��������� ������������
	ProcessingCounterparty: "Processing_Counterparty" //�� ������� ������������
});

export const settings = {
	statuses: statuses,
	actions: [
		{
			title: i18next.t("sendTo"),
			btnClass: "btn-secondary",
			action: bpActions.approve,
			type: actionTypes.save,
			statuses: [statuses.project, statuses.preparation, statuses.signedCounterparty, statuses.additionalSigningCounterparty, statuses.preparationCounterparty, statuses.refinementCounterparty]
		},
		{
			title: i18next.t("signOrElectronicSeal"),
			btnClass: "btn-primary",
			type: actionTypes.sign,
			statuses: [statuses.project, statuses.additionalSigningCounterparty, statuses.signingCounterparty, statuses.signedCounterparty, statuses.preparationCounterparty, statuses.refinementCounterparty]
		},
		{
			title: i18next.t("reject"),
			btnClass: "btn-secondary",
			action: bpActions.reject,
			type: actionTypes.reject,
			statuses: [statuses.additionalSigningCounterparty, statuses.signingCounterparty]
		},
		{
			title: i18next.t("forAdditionalSigning"),
			btnClass: "btn-secondary",
			action: bpActions.additionalSigning,
			type: actionTypes.additionalSign,
			statuses: [statuses.project, statuses.signedCounterparty, statuses.preparationCounterparty, statuses.refinementCounterparty]
		},
		{
			title: i18next.t("edit"),
			btnClass: "btn-secondary",
			type: actionTypes.edit,
			statuses: [statuses.project, statuses.signedCounterparty, statuses.preparationCounterparty, statuses.refinementCounterparty]
		},
		{
			title: i18next.t("cancel"),
			btnClass: "btn-secondary",
			action: bpActions.annul,
			type: actionTypes.annul,
			statuses: [documentStatuses.project, documentStatuses.refinementCounterparty, documentStatuses.signedCounterparty, documentStatuses.preparationCounterparty],
			modes: [formModes.read]
		}
	]
}

export function getCurAttacmentsTypes() {
	const { attachmentsTypes, prop_sxcfc_counterpartyType, prop_sxcfc_counterpartyKind, type, prop_sxcfc_certifiedISCC } = this.state;
	let result = attachmentsTypes?.filter((item) =>
		item.configuration?.some((conf) => conf.counterpartyType === prop_sxcfc_counterpartyType && conf.counterpartyKind === prop_sxcfc_counterpartyKind && (conf.portalEnabled))
	);
	if (type === alfrescoTypes.certificate && prop_sxcfc_counterpartyKind === counterpartyKind.Maker && prop_sxcfc_certifiedISCC) {
		result = result.filter(item => item.value === certificateAttachedTypes.ISCCEU_8 || item.value === certificateAttachedTypes.ISCCEU_9);
	}
	return result;
}
export function copyAddress() {
	this.setState({
		prop_sxcfc_index: this.state.prop_sxcfc_laIndex,
		prop_sxcfc_region: this.state.prop_sxcfc_laRegion,
		prop_sxcfc_area: this.state.prop_sxcfc_laArea,
		prop_sxcfc_city: this.state.prop_sxcfc_laCity,
		prop_sxcfc_street: this.state.prop_sxcfc_laStreet,
		prop_sxcfc_building: this.state.prop_sxcfc_laBuilding,
		prop_sxcfc_apartment: this.state.prop_sxcfc_laApartment
	});
}
export async function youControlRequest() {
	const { prop_sxcfc_counterpartyType, prop_sxcfc_codeEDRPOU, prop_sxcfc_codeIPN } = this.state;
	const response = await fetch('YouControl/GetUserData?registerCode=' + (prop_sxcfc_counterpartyType === companyTypes.Entity ? prop_sxcfc_codeEDRPOU : prop_sxcfc_codeIPN));
	let data = response.ok ? await response.json() : null;
	if (data) {
		this.state.prop_sxcfc_counterpartyFullName = data.companyName ? data.companyName : "";
		this.state.prop_sxcfc_counterpartyShortName = data.shortCompanyName ? data.shortCompanyName : "";
		this.state.prop_sxcfc_counterpartyFullNameENG = data.englishCompanyName ? data.englishCompanyName : "";
		this.state.prop_sxcfc_counterpartyShortNameENG = data.shortEnglishCompanyName ? data.shortEnglishCompanyName : "";
		this.state.prop_sxcfc_mainActivity = data.mainNACE ? data.mainNACE : "";
		this.state.prop_sxcfc_additionalActivity = data.additionalNACEs ? data.additionalNACEs : "";
		this.state.prop_sxcfc_counterpartyPhone = data.phone ? data.phone : "";
		this.state.prop_sxcfc_counterpartySecondPhone = data.additionalPhone ? data.additionalPhone : "";
		this.state.prop_sxcfc_counterpartyEmail = data.email ? data.email : "";
		this.state.prop_sxcfc_website = data.site ? data.site : "";
		this.state.prop_sxcfc_laIndex = data.legalIndex ? data.legalIndex : "";
		this.state.prop_sxcfc_laRegion = data.legalRegion ? data.legalRegion : "";
		this.state.prop_sxcfc_laArea = data.legalDistrict ? data.legalDistrict : "";
		this.state.prop_sxcfc_laCity = data.legalCity ? data.legalCity : "";
		this.state.prop_sxcfc_laStreet = data.legalStreet ? data.legalStreet : "";
		this.state.prop_sxcfc_laBuilding = data.legalBuilding ? data.legalBuilding : "";
		this.state.prop_sxcfc_laApartment = data.legalRoom ? data.legalRoom : "";
		this.state.signers = [];
		if (data.signerInfos && data.signerInfos.length > 0) {
			for (let i = 0; i < data.signerInfos.length; i++) {
				let currentIndex = this.state.signers.findIndex(u => u.columns.SubscriberPIB.toUpperCase() === data.signerInfos[i].subscriberPIB.toUpperCase()
					&& u.columns.SubscriberPosition.toUpperCase() === data.signerInfos[i].subscriberPosition.toUpperCase());
				if (currentIndex < 0) {
					let newUser = {
						actions: [],
						columns: {
							Id: require('uuid').v4(),
							SubscriberPIB: data.signerInfos[i].subscriberPIB,
							SubscriberPosition: data.signerInfos[i].subscriberPosition,
							TitleDocument: data.signerInfos[i].titleDocument
						}
					}
					this.state.signers.push(newUser);
				}
			}
		}
		this.setState({
			submitted: true
		});
		showModalDialog('modalDialog', i18next.t("done"), "", <div className="info-message">{i18next.t("youcontrolSuccesMessage")}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: () => hideModalDialog('modalDialog'), class: "btn-primary" }]);
	} else badYoucontrolRequestDialog();
}
export function getAttachmentConfiguration(attachment, properties) {
	let { prop_sxcfc_counterpartyType, prop_sxcfc_counterpartyKind, attachmentsTypes, type, prop_sxcfc_certifiedISCC } = properties;
	let { documentType } = attachment;
	if (type === alfrescoTypes.certificate && prop_sxcfc_counterpartyKind === counterpartyKind.Maker && prop_sxcfc_certifiedISCC) {
		attachmentsTypes = attachmentsTypes.filter(item => item.value === certificateAttachedTypes.ISCCEU_8 || item.value === certificateAttachedTypes.ISCCEU_9);
		attachmentsTypes.forEach(attachmentType => {
			attachmentType.configuration.forEach(config => {
				config.portalMandatoryAdding = true;
				config.portalMandatorySigning = true;
			});
		});
	}
	else {
		let certificateTypes = attachmentsTypes.filter(item => item.value === certificateAttachedTypes.ISCCEU_8 || item.value === certificateAttachedTypes.ISCCEU_9);
		certificateTypes.forEach(attachmentType => {
			attachmentType.configuration.forEach(config => {
				config.portalMandatoryAdding = false;
				config.portalMandatorySigning = false;
			});
		});
	}
	let configuration = attachmentsTypes.find((item) => item.value === documentType)?.configuration?.find((item) =>
		(item.counterpartyType === prop_sxcfc_counterpartyType && item.counterpartyKind === prop_sxcfc_counterpartyKind)
	);
	return configuration;
}
export function getAttachmentIndicator(attachment) {
	if (attachment) {
		let { state } = attachment;
		let configuration = this.getAttachmentConfiguration(attachment, this.state);
		if (configuration) {
			if ((state === attachmentStatuses.NotAdded || state === attachmentStatuses.Missing) && configuration?.portalMandatoryAdding)
				return <img src="/img/icn-alert.svg" title={i18next.t("mandatoryDocument")} alt="" />;
			else if (state === attachmentStatuses.New)
				return <img src="/img/icn-need-sign.svg" title={i18next.t("signatureRequired")} alt="" />;
		}
	}
}
export function checkAttachmentsMandatoryAdding() {
	const { attachments } = this.state;
	for (let i = 0; i < attachments.length; ++i) {
		let configuration = this.getAttachmentConfiguration(attachments[i], this.state);
		let state = attachments[i].state;
		if (configuration) {
			if ((state === attachmentStatuses.NotAdded)) {
				if (configuration.portalMandatoryAdding) {
					return false;
				}
			}
		}
	}
	return true;
}
export function checkAttachmentsMandatorySigning() {
	const { attachments } = this.state;
	for (let i = 0; i < attachments.length; ++i) {
		let state = attachments[i].state;
		if (state === attachmentStatuses.New)
			return false;
	}
	return true;
}
export function addSigner(accountant) {
	let title = accountant ? i18next.t("addAccountant") : i18next.t("addSignatory");
	let onSubmit = (user) => {
		this.addUser(user);
		if (user.IsAccountant) {
			this.setState({ prop_sxcfc_hasAccountant: true });
			messageDialog(i18next.t("done"), i18next.t("accountantAdded"));
		}
	}
	showModalDialog('modalDialog', title, "", <EditSignerForm formType={SignerFormTypes.create} isAccountant={accountant} onSubmitHandler={onSubmit} onCloseHandler={() => hideModalDialog('modalDialog')} />, "feedPopup with-header-btns");
}
export function addAttacment(attacment) {
	attacment.state = attachmentStatuses.New;
	let typesOfDocumens = this.getCurAttacmentsTypes();
	let curType = typesOfDocumens.find((item) => {
		return item.value === attacment.documentType;
	});
	if (attacment.file) {
		attacment.title = curType.title;
		let fileNameParts = attacment.file.name.split('.');
		if (fileNameParts.length > 0) {
			let extension = fileNameParts[fileNameParts.length - 1].toLowerCase();
			attacment.title += '.' + extension;
			let index = 2;
			while (this.state.attachments.find(a => a.title === attacment.title)) {
				attacment.title = `${curType.title} (${index.toFixed()}).${extension}`;
				index++;
			}
		}
	}
	let replaceIndex = this.state.attachments.findIndex(a => a.documentType === curType.value && (a.state === attachmentStatuses.NotAdded || a.state === attachmentStatuses.Missing));
	if (replaceIndex >= 0) {
		this.state.attachments[replaceIndex] = attacment;
		this.setState({
			attachments: this.state.attachments
		});
	}
	else {
		this.setState({
			attachments: [...this.state.attachments, attacment]
		});
	}
	hideModalDialog('modalDialog')
}
export function buildFormItem(item) {
	const { prop_sxcfc_counterpartyType } = this.state;
	if ((item.Name === "prop_sxcfc_codeIPN")) {
		item.Patern = prop_sxcfc_counterpartyType === companyTypes.Entity ? formStringFieldPatterns.legalPersonIPN : formStringFieldPatterns.codeIPN;
		item.Disabled = prop_sxcfc_counterpartyType === companyTypes.Individual;
		item.Required = item.Required && prop_sxcfc_counterpartyType !== companyTypes.Entity;
		return item;
	}
	else if ((this.state.prop_sxcfc_counterpartyType !== companyTypes.Entity && item.Name === "prop_sxcfc_codeEDRPOU") ||
		(this.state.prop_sxcfc_counterpartyKind !== counterpartyKind.Maker &&
			(item.Name === "prop_sxcfc_landOwned" || item.Name === "prop_sxcfc_landRent"))) {
	}
	else {
		item.Type = this.state.prop_sxcfc_PDVPayer === false && item.Name === "prop_sxcfc_PDVNumber" ? formFieldTypes.empty : item.Type;
		return item;
	}
}
export function deleteSigners(ids) {
	const { signers } = this.state;
	if (signers && signers.length > 0) {
		this.state.signers = signers.filter(s => !ids.includes(s.columns.Id));
		let hasAccountant = this.state.signers.some(s => s.columns.IsAccountant);
		this.setState({
			signers: this.state.signers,
			prop_sxcfc_hasAccountant: hasAccountant
		});
	}
	globalEventDispatcher.dispatch(dispatcherActionTypes.onUnselectTableAllRows);
}
export function deleteAccountant() {
	const { signers } = this.state;
	if (signers && signers.length > 0) {
		this.state.signers = signers.filter(s => !s.columns.IsAccountant);
		this.setState({
			signers: this.state.signers,
			prop_sxcfc_hasAccountant: false
		});
	}
	globalEventDispatcher.dispatch(dispatcherActionTypes.onUnselectTableAllRows);
}